import { useEffect, useState } from "react";
import { Package, Tags, Smartphone, CheckCircle2, XCircle, AlertTriangle, MessageCircle, TrendingUp, Search } from "lucide-react";
import { api } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

const CARDS = [
  { key: "total_products", label: "Total Produk", icon: Package, color: "text-slate-700 bg-slate-100" },
  { key: "total_categories", label: "Kategori", icon: Tags, color: "text-indigo-700 bg-indigo-100" },
  { key: "total_models", label: "Tipe HP", icon: Smartphone, color: "text-cyan-700 bg-cyan-100" },
  { key: "active_products", label: "Produk Aktif", icon: CheckCircle2, color: "text-emerald-700 bg-emerald-100" },
  { key: "limited_stock", label: "Stok Terbatas", icon: AlertTriangle, color: "text-amber-700 bg-amber-100" },
  { key: "out_of_stock", label: "Produk Habis", icon: XCircle, color: "text-rose-700 bg-rose-100" },
  { key: "total_clicks", label: "Klik WhatsApp", icon: MessageCircle, color: "text-green-700 bg-green-100" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  if (!stats) return <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">{Array.from({ length: 7 }).map((_, i) => <Skeleton key={i} className="h-28 rounded-2xl" />)}</div>;

  return (
    <div>
      <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Dashboard</h1>
      <p className="mt-1 text-sm text-muted-foreground">Ringkasan performa toko UPPLESORIES.</p>

      <div className="mt-6 grid gap-4 grid-cols-2 lg:grid-cols-4" data-testid="dashboard-stats">
        {CARDS.map((c) => (
          <div key={c.key} className="rounded-2xl border border-border bg-card p-4">
            <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${c.color}`}><c.icon className="h-4 w-4" /></div>
            <p className="mt-3 font-heading text-2xl font-bold">{stats[c.key]}</p>
            <p className="text-xs text-muted-foreground">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        <div className="rounded-2xl border border-border bg-card p-5">
          <h2 className="flex items-center gap-2 font-heading font-semibold"><TrendingUp className="h-4 w-4 text-accent" /> Produk Paling Sering Diklik</h2>
          <div className="mt-4 space-y-2">
            {stats.top_products.length === 0 && <p className="text-sm text-muted-foreground">Belum ada data klik.</p>}
            {stats.top_products.map((p, i) => (
              <div key={i} className="flex items-center justify-between rounded-xl bg-secondary px-3 py-2 text-sm">
                <span className="truncate">{i + 1}. {p.name}</span>
                <span className="font-semibold">{p.click_count}x</span>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <h2 className="flex items-center gap-2 font-heading font-semibold"><Search className="h-4 w-4 text-accent" /> Tipe HP Paling Dicari</h2>
          <div className="mt-4 space-y-2">
            {stats.top_searched_models.length === 0 && <p className="text-sm text-muted-foreground">Belum ada data pencarian.</p>}
            {stats.top_searched_models.map((m, i) => (
              <div key={i} className="flex items-center justify-between rounded-xl bg-secondary px-3 py-2 text-sm">
                <span className="truncate">{i + 1}. {m.name}</span>
                <span className="font-semibold">{m.count}x</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
